import React from 'react'
import { useTranslation } from 'react-i18next'
import { PreschoolerBirthdays } from '../landing-page/availability-tab/type'

interface DateSelectionFieldProps {
  name?: string
  onChange?: (date: { year: string; month: string; day: string }) => void
  hasError?: boolean
  value: PreschoolerBirthdays
}

export const DateSelectionField: React.FC<DateSelectionFieldProps> = ({
  name = 'fronts_reservation[children_birth_day][]',
  onChange,
  hasError = false,
  value,
}) => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 20
  const endYear = currentYear

  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange({ ...value, year: e.target.value })
    }
  }

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange({ ...value, month: e.target.value })
    }
  }

  const handleDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange({ ...value, day: e.target.value })
    }
  }

  return (
    <div className="flex">
      <select
        className={`date-selection-year text-sm text-gray-900 pl-2 py-3 rounded-lg bg-gray-50 mt-2 select-check date-selection md:w-[143px]`}
        onChange={handleYearChange}
        style={{
          borderColor: hasError ? 'red' : '#E5E7EB',
        }}
        value={value.year}
      >
        <option value="">{t('common.foot_consultation.year_suffix')}</option>
        {Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i)
          .sort((a, b) => b - a)
          .map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
      </select>
      <span className="col-start-11 col-span-2 mt-auto px-2">{t('common.foot_consultation.year')}</span>

      <select
        className={`date-selection-month text-sm text-gray-900 pl-2 py-3 rounded-lg bg-gray-50 mt-2 select-check date-selection w-[70px]`}
        onChange={handleMonthChange}
        style={{
          borderColor: hasError ? 'red' : '#E5E7EB',
        }}
        value={value.month}
      >
        <option value="">{t('common.foot_consultation.month')}</option>
        {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>
      <span className="col-start-11 col-span-2 pl-2 ml-1 mt-auto px-2 md:ml-0">{t('common.foot_consultation.month')}</span>

      <select
        className={`date-selection-day text-sm text-gray-900 pl-2 py-3 rounded-lg bg-gray-50 mt-2 select-check date-selection w-[70px]`}
        data-date-selection-target="day"
        data-validation-name="日"
        name={name}
        value={value.day}
        onChange={handleDayChange}
        style={{
          borderColor: hasError ? 'red' : '#E5E7EB',
        }}
      >
        <option value="">{t('common.foot_consultation.day')}</option>
        {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
          <option key={day} value={day}>
            {day}
          </option>
        ))}
      </select>
      <span className="col-start-11 col-span-2 pl-2 ml-4 mt-auto md:pl-2 md:ml-0">{t('common.foot_consultation.day')}</span>
    </div>
  )
}
